<template>
  <div class="step">
    <ActivationOverlay ref="activationOverlay" />
    <div class="step__container">
      <div class="step__header" v-if="!isPublished">
        Din annonce er nu færdig
      </div>
      <div class="step__text" v-if="!isPublished">
        Herunder ser du en opsummering af dine informationer om
        {{ privateAdFlowProductTypeNames.nameSingularParticular }}.
      </div>
      <div class="step__header" v-if="isPublished">
        Din annonce er nu aktiv!
      </div>
      <div class="step__text" v-if="isPublished">
        Den vil nu blive vist til potentielle købere ved relevante søgninger. Du
        kan følge antal visninger på "Mit Biltorvet" under
        <a :href="myAdsUrl" class="step__text--link">"Mine annoncer"</a>, hvor
        du også kan foretage ændringer til annoncen løbende.
      </div>
    </div>
    <div class="step__box">
      <dl class="step__list">
        <template v-for="data in tableData" :key="'template_' + data.key">
          <dt class="step__type" v-html="data.key"></dt>
          <dd
            class="step__definition step__definition--bold"
            v-html="data.value"
          ></dd>
        </template>
      </dl>
    </div>
    <StepButtonPanel
      :event-bus="eventBus"
      :back-visible="backVisible"
      :publish-visible="true"
      :publish-enabled="isValid"
      :is-update="isUpdate"
      :is-active="isPublished"
      :ad-url="adUrl"
      :dashboard-url="dashboardUrl"
      :link-dashboard-visible="linkDashboardVisible"
    ></StepButtonPanel>
    <SolgtComBanner :location="'Create'" />
  </div>
</template>
<script>
import { app } from '@/main'

import {
  LogPrivateAdActivate,
  PrivateAdFlowStep5PublishClicked,
} from '@/events'

import ActivationOverlay from '@components/ActivationOverlay/ActivationOverlay.vue'
import SolgtComBanner from '@components/SolgtComBanner/SolgtComBanner.vue'
import StepButtonPanel from '../Components/StepButtonPanel/StepButtonPanel.vue'

export default {
  components: {
    StepButtonPanel,
    ActivationOverlay,
    SolgtComBanner,
  },
  props: {
    myAdsUrl: { default: '', type: String },
    dashboardUrl: { default: '', type: String },
    eventBus: { default: null, type: Object },
    adId: { default: 0, type: Number },
    contactInformation: {
      default: () => {
        return {}
      },
      type: Object,
    },
    tableData: {
      default: () => {
        return []
      },
      type: Array,
    },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
    isActive: { default: false, type: Boolean },
    isUpdate: { default: false, type: Boolean },
    initialAdUrl: { default: '', type: String },
  },
  data() {
    return {
      isValid: true,
      adUrl: '',
      isPublished: false,
      backVisible: true,
      linkDashboardVisible: false,
    }
  },
  methods: {
    validate() {
      return true
    },
    publish() {
      let phone = ''
      if (this.contactInformation && this.contactInformation.phone) {
        phone = this.contactInformation.phone.toString()
      }

      this.$refs.activationOverlay.openForm(
        this.adId,
        phone,
        this.publishSucceeded
      )

      // Hvis brugeren lukker dialogen, skal udgiv knappen være tilgængelig igen.
      const owner = this
      setTimeout(() => {
        owner.eventBus.emit('step-changed')
      }, 500)
    },
    publishSucceeded(adUrl) {
      this.adUrl = adUrl
      this.isPublished = true
      this.backVisible = false
      this.linkDashboardVisible = true
      app.toast.success('Din annonce er nu aktiv')
      LogPrivateAdActivate()
      PrivateAdFlowStep5PublishClicked()
    },
  },
  mounted() {
    this.eventBus.emit('stepLoaded', 5)
  },
  created() {
    window.scrollTo(0, 0)
    this.adUrl = this.initialAdUrl
    this.isPublished = this.isActive
    app.mitt.on('initiate-publish', this.publish)

    if (this.isPublished) {
      this.backVisible = false
      this.linkDashboardVisible = true
    }
  },
  beforeUnmount() {
    app.mitt.off('initiate-publish', this.publish)
  },
}
</script>

<style lang="scss">
@import 'Step.scss';
</style>
